import type { OrientaceDispleje } from '../api/JsdhNotifikaceService/generated/models/Device';
import type { PoplachPreset } from '../api/JsdhNotifikaceService/generated/models/DeviceToken';

// Volba v UI -> DB -> xrandr (spec kiosek na výšku, kap. 5.4). xrandr --rotate left otáčí obsah
// proti směru hodinových ručiček, proto patří k monitoru otočenému po směru. Mapování LEFT/RIGHT
// na popisky se ověřuje ručně na develop RPi (runbook 14); popisky odpovídají tomuto mapování.
export const ORIENTACE_MONITORU_VOLBY: { hodnota: OrientaceDispleje; popisek: string }[] = [
    { hodnota: 'NORMAL', popisek: 'Na šířku' },
    { hodnota: 'LEFT', popisek: 'Na výšku – otočený po směru hodinových ručiček' },
    { hodnota: 'RIGHT', popisek: 'Na výšku – otočený proti směru hodinových ručiček' },
];

export const NAPOVEDA_ORIENTACE_MONITORU = [
    'Změna se projeví do 5 minut a jen na zařízení s aktuálními skripty kiosku.',
    'Když je obraz vzhůru nohama, zvolte druhou variantu na výšku.',
];

export const UPOZORNENI_PRESET_NA_VYSKU =
    'Na výšku je optimalizovaný jen preset „Výjezd – rozšířený“. Preset tohoto monitoru změníte na záložce Obrazovka.';

/** Upozornit, když je monitor na výšku a preset není vyjezd-2026 (custom nebo legacy zvolený zpět). */
export const zobrazitUpozorneniNaVysku = (orientace?: OrientaceDispleje, preset?: PoplachPreset): boolean =>
    (orientace === 'LEFT' || orientace === 'RIGHT') && preset !== 'vyjezd-2026';
